import React from "react";
import "./StockistReport.css";
import StockistReportHeader from "../stockist_report/StockistReportHeader";
import Sidebar from "../operator_home/sidebar/Sidebar";
import OtherSidebar from "../supervisor_home/sidebar/Sidebar";
import StockistReportMain from "../stockist_report/StockistReportMain";
import { ReactSession } from "react-client-session";

const StockistReport = () => {
  const role = ReactSession.get("role");
  return (
    <div className="stockistreport-container">
      <StockistReportHeader />
      {role === "2" ? <OtherSidebar /> : <Sidebar />}
      <StockistReportMain />
    </div>
  );
};

export default StockistReport;
